import { useEffect } from "react"
import { useDispatch } from "react-redux"

export const useRevalidateFetch = ( action=null, data=[] ) => {
  const dispatch = useDispatch()
  useEffect(() => {
    data?.length === 0 && dispatch(action())
  }, [data])
}